<template>
	<div class="quote-success-view">
		<div class="success-badge">
			<rt-picture class="icon-rocket" src="/assets/app/class/icon-infinite-rocket.svg" :autosize="false"/>
			<rt-picture class="icon-success" src="/assets/app/quiz/icon-answer-passed.svg" :autosize="false"/>
		</div>
		<h2 class="success-title">Request sent successfully</h2>
		<p class="success-description">We will contact you shortly!</p>
		<primary-button class="btn-close" @click="handleClickClose">Close</primary-button>
	</div>
</template>

<script>

import RtPicture from '../common/Picture.vue';
import PrimaryButton from '../common/PrimaryButton.vue';

export default {
	components: {
		RtPicture,
		PrimaryButton
	},
	methods: {
		handleClickClose() {
			this.$emit('onClose');
		}
	}
}

</script>

<style lang="scss" scoped>

@import '../common/variables';

.quote-success-view {
	display: flex;
	flex-direction: column;
	align-items: center;
	.success-badge {
		position: relative;
		.icon-rocket {
			width: 165px;
		}
		.icon-success {
			width: 60px;
			position: absolute;
			left: -16px;
			top: -1px;
		}
	}

	.success-title {
		margin-top: 30px;
		font-family: $title-font;
		font-weight: $font-bold;
		font-size: 30px;
	}
	.success-description {
		color: $title-grey;
	}

	.btn-close {
		margin: 0;
		margin-top: 60px;
		width: 160px;
		padding-top: 1rem;
		border: 0;
		text-align: center;
	}
}

</style>
